import { Map } from 'leaflet';
import { ReactElement, useEffect } from 'react';
import { useMap } from 'react-leaflet';

export interface IMapReferenceProps {
	onMapReference: (map: Map) => void;
}

export function MapReference(props: IMapReferenceProps): ReactElement {
	const reference: Map = useMap();
	const { onMapReference } = props;

	useEffect(() => {
		if (reference) {
			onMapReference(reference);
		}
	}, [reference]);

	return <></>;
}
